import { render, staticRenderFns } from "./imcGraph.vue?vue&type=template&id=978406d8&scoped=true"
import script from "./imcGraph.vue?vue&type=script&lang=js"
export * from "./imcGraph.vue?vue&type=script&lang=js"
import style0 from "./imcGraph.vue?vue&type=style&index=0&id=978406d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978406d8",
  null
  
)

export default component.exports